import { useState } from 'react';
import { asyncSimpleModal } from '../../../../../lib/common';
import useCategoryExhibitOrderEdit from '../../../../../hooks/queries/category/useCategoryExhibitOrderEdit';

export const useCategoryExhibitNavbar = (props) => {
  const {
    form,
    exhibitGeneralCategoryDataSource,
    exhibitEmphasisCategoryDataSource,
    setSelectedExhibitMainCategoryList,
    setSelectedExhibitSubCategoryList,
    setSelectedTotalMainCategoryList,
    setSelectedTotalSubCategoryList,
  } = props;

  // 카테고리 전시 편집 중 여부
  const [isEditable, setIsEditable] = useState(false);

  const { editCategoryExhibitOrder } = useCategoryExhibitOrderEdit(setIsEditable, form);

  const onSubmit = async () => {
    const result = await asyncSimpleModal({
      type: 'confirm',
      title: '카테고리 전시 설정',
      message: '사용자 화면에 반영 하시겠습니까?',
    });

    if (!result) return;

    // 일반형 카테고리 순서 리스트
    const normalCategories = exhibitGeneralCategoryDataSource.map((mainCategory) => ({
      id: mainCategory.id,
      name: mainCategory.name,
      subCategories: mainCategory.children.map((subCategory) => ({
        id: subCategory.id,
        name: subCategory.name,
      })),
    }));

    // 강조형 카테고리 순서 리스트
    const emphasisCategories = exhibitEmphasisCategoryDataSource.map((mainCategory) => ({
      id: mainCategory.id,
      name: mainCategory.name,
      subCategories: mainCategory.children.map((subCategory) => ({
        id: subCategory.id,
        name: subCategory.name,
      })),
    }));

    // 카테고리 전시 순서 변경 mutate
    editCategoryExhibitOrder.mutate({
      normalCategories,
      emphasisCategories,
    });

    // 전시 카테고리, 전체 카테고리에서 선택한 카테고리 배열 초기화(1,2차 카테고리)
    setSelectedExhibitMainCategoryList([]);
    setSelectedExhibitSubCategoryList([]);
    setSelectedTotalMainCategoryList([]);
    setSelectedTotalSubCategoryList([]);
  };

  return { isEditable, setIsEditable, onSubmit };
};
